module.exports = __webpack_public_path__ + "static/media/uploadedFile.6ce57ba5.svg";